// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___QWZLd","root__message":"style-module__root__message___X_WG3","root__message__text":"style-module__root__message__text___dmJKB","root__btn":"style-module__root__btn___HFYez"};
    if(module.hot) {
      // 1729151130071
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  